<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <div class="shadow-bottom"></div>

            <perfect-scrollbar class="list-unstyled menu-categories" tag="ul"
                :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
                <li class="menu">
                    <router-link to="/home" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-home">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                            <span>{{ $t('dashboard') }}</span>
                        </div>
                    </router-link>
                </li>

                <!-- <li class="menu">
                    <router-link to="/violator/view" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-users">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span>{{ $t('View Violators') }}</span>
                        </div>
                    </router-link>
                </li> -->

                <!-- Violation Actions MA CARGO -->
                <li v-if="isMaCargo" class="menu">
                    <router-link to="/violation/list" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-layout">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="3" y1="9" x2="21" y2="9"></line>
                                <line x1="9" y1="21" x2="9" y2="9"></line>
                            </svg>
                            <span>{{ $t('Violations') }}</span>
                        </div>
                    </router-link>
                </li>
                <!-- END -->

                <!-- REPORTS MA CARGO -->
                <li v-if="isMaCargo" class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#mareports"
                        aria-controls="mareports" aria-expanded="false">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-layers">
                                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                <polyline points="2 17 12 22 22 17"></polyline>
                                <polyline points="2 12 12 17 22 12"></polyline>
                            </svg>
                            <span>{{ $t('Reports') }}</span>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-right">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>

                    <ul id="mareports" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/violation/reports/detailed" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Detailed Reports') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/violation/reports/summary" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Summary Reports') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/violation/reports/drivers" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Driver Reports') }}</span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- END -->

                <!-- Violation Actions ABS -->
                <li v-if="isABS" class="menu">
                    <router-link to="/abs/violation/list" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-layout">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="3" y1="9" x2="21" y2="9"></line>
                                <line x1="9" y1="21" x2="9" y2="9"></line>
                            </svg>
                            <span>{{ $t('Violations') }}</span>
                        </div>
                    </router-link>
                </li>
                <!-- END -->

                <!-- REPORTS ABS -->
                <li v-if="isABS" class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#reports"
                        aria-controls="reports" aria-expanded="false">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-layers">
                                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                <polyline points="2 17 12 22 22 17"></polyline>
                                <polyline points="2 12 12 17 22 12"></polyline>
                            </svg>
                            <span>{{ $t('Reports') }}</span>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-right">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>

                    <ul id="reports" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/abs/violation/reports/detailed" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Detailed Reports') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/abs/violation/reports/summary" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Summary Reports') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/abs/violation/reports/bus" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Individual Reports') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li v-if="hasViewTrafficFinesPermission">
                            <router-link to="/abs/traffic-fines/vehicle" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Traffic Fines') }}</span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </li>
                <!-- END -->

                <li class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#settings"
                        aria-controls="settings" aria-expanded="false">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-zap">
                                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                            </svg>
                            <span>{{ $t('Settings') }}</span>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-right">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>

                    <ul id="settings" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/violation/view" class="dropdown-toggle" @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('View Violations') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/violation/parameters/view" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('View Details') }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/violation/actions_taken/view" class="dropdown-toggle"
                                @click="toggleMobileMenu">
                                <div class="">
                                    <span>{{ $t('Actions Taken') }}</span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li v-if="hasViewAppsPermission" class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#apps" aria-controls="apps"
                        aria-expanded="false">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-cpu">
                                <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                <rect x="9" y="9" width="6" height="6"></rect>
                                <line x1="9" y1="1" x2="9" y2="4"></line>
                                <line x1="15" y1="1" x2="15" y2="4"></line>
                                <line x1="9" y1="20" x2="9" y2="23"></line>
                                <line x1="15" y1="20" x2="15" y2="23"></line>
                                <line x1="20" y1="9" x2="23" y2="9"></line>
                                <line x1="20" y1="14" x2="23" y2="14"></line>
                                <line x1="1" y1="9" x2="4" y2="9"></line>
                                <line x1="1" y1="14" x2="4" y2="14"></line>
                            </svg>
                            <span>{{ $t('apps') }}</span>
                        </div>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-right">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </div>
                    </a>
                    <ul id="apps" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/apps/chat" @click="toggleMobileMenu">Chat</router-link>
                        </li>
                        <li>
                            <router-link to="/apps/mailbox" @click="toggleMobileMenu">Mailbox</router-link>
                        </li>
                        <li>
                            <router-link to="/apps/todo-list" @click="toggleMobileMenu">Todo List</router-link>
                        </li>
                        <li>
                            <router-link to="/apps/notes" @click="toggleMobileMenu">Notes</router-link>
                        </li>
                    </ul>
                </li>
            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const userCompanyID = ref(store.state.currentCompany?.id || null);
console.log('User Company ID:', userCompanyID.value);

const isMaCargo = computed(() => userCompanyID.value === 2);
const isABS = computed(() => userCompanyID.value === 3);
const hasViewAppsPermission = computed(() => store.getters.hasPermission('view_apps'));
const hasViewTrafficFinesPermission = computed(() => store.getters.hasPermission('view_abs_traffic_fines'));

const menu_collapse = ref('dashboard');

onMounted(() => {
    const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
    if (selector) {
        const ul = selector.closest('ul.collapse');
        if (ul) {
            let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
            if (ele) {
                ele = ele[0];
                setTimeout(() => {
                    ele.click();
                });
            }
        } else {
            selector.click();
        }
    }
});

const toggleMobileMenu = () => {
    if (window.innerWidth < 991) {
        store.commit('toggleSideBar', !store.state.is_show_sidebar);
    }
};
</script>
